import React from 'react';
import { Heart } from 'lucide-react';
import { useLanguage } from '../LanguageContext';

export const Footer = () => {
  const { t, language } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-decoration">
          <div className="footer-line"></div>
          <Heart className="footer-heart" fill="currentColor" />
          <div className="footer-line"></div>
        </div>
        
        <div className="footer-names">
          <h3>Hatem & Nourhene</h3>
        </div>
        
        <p className="footer-date">{language === 'fr' ? '1er Mai 2027' : 'May 1st, 2027'}</p>
        
        <div className="footer-bottom">
          <p>
            {t('footer.madeWith')} <Heart size={14} fill="currentColor" style={{display: 'inline', verticalAlign: 'middle'}} /> {t('footer.by')} Emergent
          </p>
          <p style={{marginTop: '10px', fontSize: '0.85rem', opacity: 0.8}}>
            © {currentYear} Hatem & Nourhene
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
